<script lang="ts" setup>
import { formatPrice } from '~/utils'

const { amount } = defineProps<{
  amount?: string
}>()

const { investmentAmount, calc, solYear, solDay, solMonth } = useRoiCalculator()

function totalAmount(val: number) {
  return formatPrice(Number(val || 0) + Number(investmentAmount.value) || 0, 2, 4)
}
watch(() => amount, (amount) => {
  investmentAmount.value = amount !== '.' && amount ? amount : '0'
  calc()
})
</script>

<template>
  <div class="estimate-calc">
    <span class="text-sm estimate-calc__title">You will get</span>
    <div class="estimate-calc__content">
      <div class="estimate-calc__item">
        <span class="text-sm">Estimated Reward   |   Year</span>
        <span class="text-lg">{{ totalAmount(solYear) }}</span>
      </div>
      <div class="estimate-calc__item">
        <span class="text-sm">Estimated Reward   |  Month</span>
        <span class="text-lg">{{ totalAmount(solMonth) }}</span>
      </div>
      <div class="estimate-calc__item">
        <span class="text-sm">Estimated Reward   |  Day</span>
        <span class="text-lg">{{ totalAmount(solDay) }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.estimate-calc {
  @media (max-width: $breakpoint-xs) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 4px;
  }

  &__title {
    padding-bottom: $space-xs;
    display: block;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    text-transform: uppercase;

    @media (max-width: $breakpoint-xs) {
      width: 100%;
      font-size: 12px;
      padding-bottom: $space-xs;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: $space-sm 0;
    border-bottom: 1px solid $gray-02;

    span {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0.14px;
      font-variant-numeric: slashed-zero tabular-nums;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (max-width: $breakpoint-xxs) {
        line-height: 100%;
        width: 100%;

        &:first-child {
          flex: 1 0 50%;
        }
      }

      &:last-child {
        margin-bottom: -4px;
        width: 54px;
        text-align: right;
        font-size: 18px;
        font-weight: 800;
        line-height: normal;
      }
    }
  }
}
</style>
